"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifierNamesGenerator = void 0;
const tsenum_1 = require("@gradecam/tsenum");
exports.IdentifierNamesGenerator = tsenum_1.MakeEnum({
    DictionaryIdentifierNamesGenerator: 'dictionary',
    HexadecimalIdentifierNamesGenerator: 'hexadecimal',
    MangledIdentifierNamesGenerator: 'mangled',
    MangledShuffledIdentifierNamesGenerator: 'mangled-shuffled'
});
